// src/store/authSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null,
  subscription: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload; // { token, user, subscription }
      // Store in session storage
      localStorage.setItem('user', JSON.stringify(action.payload));
      // console.log('User logged in:', state.user);
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      // Clear from session storage
      localStorage.removeItem('user');
    },
    // New action to restore session
    restoreSession(state, action) {
      if (action.payload) {
        state.isAuthenticated = true;
        state.user = action.payload;
      }
    },
  },
});

export const { login, logout, restoreSession } = authSlice.actions;
export default authSlice.reducer;
